"use strict";
require("./warnAboutDeprecatedCJSRequire")("Link");
module.exports = require("./index.js").Link;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-dom/Link.js
// module id = 386
// module chunks = 0